import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import TechnologyLikeButton from './community/TechnologyLikeButton';

const STATUS_STYLES = {
  on: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-400',
  'in-progress': 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-400',
  requested: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-400',
  'needs-approval': 'bg-amber-100 text-amber-800 dark:bg-amber-900/20 dark:text-amber-400',
  approved: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-400',
  hidden: 'bg-purple-100 text-purple-800 dark:bg-purple-900/20 dark:text-purple-400',
  off: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
};

const STATUS_LABELS = {
  on: 'On',
  'in-progress': 'In Progress',
  requested: 'Requested',
  'needs-approval': 'Needs Approval',
  approved: 'Approved',
  hidden: 'Hidden',
  off: 'Off',
};

const TechnologyAutomationCard = ({
  automation,
  status,
  onClick,
  onLike,
  likeLoading = false,
}) => {
  const { darkMode } = useTheme();
  const emoji = automation.emojis?.[0] || '🤖';
  const statusKey = status || 'off';

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => e.key === 'Enter' && onClick?.()}
      className={`flex flex-col rounded-xl border cursor-pointer hover:shadow-md transition-shadow p-3 h-full ${
        darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
      }`}
    >
      <div className="flex items-start gap-2 mb-2">
        <span className="text-xl shrink-0 leading-none">{emoji}</span>
        <div className="flex-1 min-w-0 flex items-center gap-2">
          <h3 className={`text-sm font-semibold line-clamp-2 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
            {automation.name || 'Untitled Automation'}
          </h3>
          <span
            className={`shrink-0 px-1.5 py-0.5 rounded-full text-[10px] font-semibold leading-none ${
              darkMode ? 'bg-gray-700 text-gray-300 border border-gray-600' : 'bg-gray-100 text-gray-500 border border-gray-200'
            }`}
          >
            v{automation.version || '1.0'}
          </span>
        </div>
        <span className={`shrink-0 px-1.5 py-0.5 rounded-full text-[10px] font-medium ${STATUS_STYLES[statusKey] || STATUS_STYLES.off}`}>
          {STATUS_LABELS[statusKey] || 'Off'}
        </span>
      </div>

      {automation.description && (
        <p className={`text-xs line-clamp-2 mb-2 flex-1 ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
          {automation.description}
        </p>
      )}

      {onLike && (
        <div className="mt-auto pt-1" onClick={(e) => e.stopPropagation()}>
          <TechnologyLikeButton
            likes={automation.likes ?? 0}
            likedBy={automation.likedBy ?? []}
            onToggle={onLike}
            loading={likeLoading}
          />
        </div>
      )}
    </div>
  );
};

export default TechnologyAutomationCard;
